.banner {
  position: fixed;
  inset-inline-end: 1rem;
  bottom: 1rem;
  inset-inline-start: 1rem;
  z-index: 60;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.5rem;
  align-items: center;
  justify-content: space-between;
  max-width: 56rem;
  margin: 0 auto;
  padding: 1rem 1.25rem;
  padding-bottom: max(1rem, env(safe-area-inset-bottom));
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-card);
  color: var(--color-foreground);
  box-shadow: var(--shadow-sm);
}

.content {
  display: flex;
  flex: 1 1 24rem;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
}

.actions {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 0.5rem;

  // Both choices are the same size and style, so refusing is as easy as accepting.
  > * {
    flex: 1 1 9rem;
  }

  @media (max-width: 640px) {
    width: 100%;
  }
}
